<div class="container w-75">
          <div class="text-center position-relative">
                <h1>Movie Flex</h1>
                <span>MOVIES.TV.FREE</span>
            </div>
          <div>
                <h2>About Movie Flex!</h2>
                <div>
                      <p>We love movies! Movie Flex was created for people like us who want to watch "Great Movies.
        Free." Movie Flex has full-length movies that will make you laugh, make you cry, scare the heck out of you, or
        inspire you to hug the person you love. We have compelling documentaries, foreign films, unique original web
        series, and a place that showcases the brightest film makers of tomorrow. We built Movie Flex to be the most
        user friendly movie destination on the web. No movie is more than two clicks away and they are all
        FREE.<br><br>We at Movie Flex want to thank our "parent" Screen Media Ventures, LLC for giving us a home and an
        endless flow of great films. Screen Media Ventures, LLC, founded in 1999, is the largest independent distributor
        of motion pictures to the world wide television market. The company is one of the leading motion picture
        distributors of theatrical, home video, digital and television both in the U.S. and internationally. With over
        1500 movies, Screen Media has one of the largest independently owned film libraries in the motion picture
        industry.<br><br>To keep up with all of the exciting things happening at Movie Flex.</p>
                      <p><br></p>
      <p>Movie Flex is available in over 60 countries including:</p>
      <p><br></p>
      <p>US</p>
      <p>Canada</p>
      <p>Austria</p>
      <p>Denmark</p>
      <p>Finland</p>
      <p>France</p>
      <p>Germany</p>
      <p>Ireland</p>
      <p>Norway</p>
      <p>Poland</p>
      <p>Sweden</p>
      <p>Switzerland</p>
      <p>Turkey</p>
      <p>UK</p>
      <p>Bahrain</p>
      <p>Egypt</p>
      <p>India</p>
      <p>Jordan</p>
      <p>Kuwait</p>
      <p>Lebanon</p>
      <p>Oman</p>
      <p>Qatar</p>
      <p>Saudi Arabia</p>
      <p>South Africa</p>
      <p>United Arab Emirates</p>
      <p>Yemen</p>
      <p>Argentina</p>
      <p>Belize</p>
      <p>Bolivia</p>
      <p>British Virgin Islands</p>
      <p>Chile</p>
      <p>Columbia</p>
      <p>Costa Rica</p>
      <p>Ecuador</p>
      <p>El Salvador</p>
      <p>Guatemala</p>
      <p>Mexico</p>
      <p>Nicaragua</p>
      <p>Panama</p>
      <p>Paraguay</p>
      <p>Peru</p>
      <p>Turks and Caicos</p>
      <p>Uruguay</p>
      <p>Venezuela</p>
      <p>Australia</p>
      <p>Hong Kong</p>
      <p>Korea</p>
      <p>Malaysia</p>
      <p>Micronesia</p>
      <p>New Zealand</p>
      <p>Palau</p>
      <p>Philippines</p>
      <p>Singapore</p>
    </div>
  </div>

</div>
